import request from '@utils/request';
import { parseDateToString } from '@utils/helpers';
import moment from 'moment';
import { mapRestaurantsResponse } from './helpers/mapRestaurantResponse';
const PREFIX = 'TABLES';

export const FETCH_RESTAURANTS_REQUEST = `${PREFIX} FETCH_RESTAURANTS_REQUEST`;
export const FETCH_RESTAURANTS_SUCCESS = `${PREFIX} FETCH_RESTAURANTS_SUCCESS`;
export const FETCH_RESTAURANTS_FAILURE = `${PREFIX} FETCH_RESTAURANTS_FAILURE`;

// Single day availability actions (used by reducers)
export const FETCH_TABLES_AVAILABILITY_REQUEST = `${PREFIX} FETCH_TABLES_AVAILABILITY_REQUEST`;
export const FETCH_TABLES_AVAILABILITY_SUCCESS = `${PREFIX} FETCH_TABLES_AVAILABILITY_SUCCESS`;
export const FETCH_TABLES_AVAILABILITY_FAILURE = `${PREFIX} FETCH_TABLES_AVAILABILITY_FAILURE`;

export const fetchRestaurantsRequest = () => ({
  type: FETCH_RESTAURANTS_REQUEST,
});

export const fetchRestaurantsSuccess = (payload) => ({
  type: FETCH_RESTAURANTS_SUCCESS,
  payload,
});

export const fetchRestaurantsFailure = () => ({
  type: FETCH_RESTAURANTS_FAILURE,
});

export const fetchRestaurants = (propertyId, language) => (dispatch) => {
  dispatch(fetchRestaurantsRequest());
  return request.get(`${propertyId}/tables/restaurants/all/${language}`).then(
    ({ data }) => dispatch(fetchRestaurantsSuccess(mapRestaurantsResponse(data))),
    (error) => {
      dispatch(fetchRestaurantsFailure(error));

      throw error;
    }
  );
};

export const FETCH_TABLES_WEEK_AVAILABILITY_REQUEST = `${PREFIX} FETCH_TABLES_WEEK_AVAILABILITY_REQUEST`;
export const FETCH_TABLES_WEEK_AVAILABILITY_SUCCESS = `${PREFIX} FETCH_TABLES_WEEK_AVAILABILITY_SUCCESS`;
export const FETCH_TABLES_WEEK_AVAILABILITY_FAILURE = `${PREFIX} FETCH_TABLES_WEEK_AVAILABILITY_FAILURE`;

export const fetchTablesWeekAvailabilityRequest = () => ({
  type: FETCH_TABLES_WEEK_AVAILABILITY_REQUEST,
});

export const fetchTablesWeekAvailabilitySuccess = (payload) => ({
  type: FETCH_TABLES_WEEK_AVAILABILITY_SUCCESS,
  payload,
});

export const fetchTablesWeekAvailabilityFailure = (error) => ({
  type: FETCH_TABLES_WEEK_AVAILABILITY_FAILURE,
  payload: error,
});

export const fetchTablesWeekAvailability =
  (propertyId, { visitDate, restaurant, restaurantId, adults, children }) =>
  (dispatch) => {
    dispatch(fetchTablesWeekAvailabilityRequest());
    const numDays = 7;
    const startDate = visitDate;

    const requests = new Array(numDays)
      .fill(0)
      .map((_, i) => moment(startDate).add(i, 'day').toDate())
      .map((date) => {
        const params = {
          visitDate: parseDateToString(date),
          restaurant,
          restaurantId,
          adults,
          children,
        };
        return request.get(`/${propertyId}/tables`, { params });
      });
    return Promise.all(requests)
      .then((results) => {
        const merged = results.reduce(
          (prev, { config: { params }, data }) => [...prev, { date: params['visit-date'], data }],
          []
        );
        dispatch(fetchTablesWeekAvailabilitySuccess(merged));
      })
      .catch((err) => {
        const parsedError = err.response ? err.response.data : err;
        dispatch(fetchTablesWeekAvailabilityFailure(parsedError));
      });
  };

export const FETCH_TABLES_RESTAURANT_CONFIG_REQUEST = `${PREFIX} FETCH_TABLES_RESTAURANT_CONFIG_REQUEST`;
export const FETCH_TABLES_RESTAURANT_CONFIG_SUCCESS = `${PREFIX} FETCH_TABLES_RESTAURANT_CONFIG_SUCCESS`;
export const FETCH_TABLES_RESTAURANT_CONFIG_FAILURE = `${PREFIX} FETCH_TABLES_RESTAURANT_CONFIG_FAILURE`;

export const fetchTablesRestaurantConfigRequest = () => ({
  type: FETCH_TABLES_RESTAURANT_CONFIG_REQUEST,
});

export const fetchTablesRestaurantConfigSuccess = (config, restaurant) => ({
  type: FETCH_TABLES_RESTAURANT_CONFIG_SUCCESS,
  payload: {
    config,
    restaurant,
  },
});

export const fetchTablesRestaurantConfigFailure = (error) => ({
  type: FETCH_TABLES_RESTAURANT_CONFIG_FAILURE,
  payload: error,
});

export const fetchRestaurantConfig =
  (propertyId, { visitDate, restaurant }) =>
  (dispatch) => {
    dispatch(fetchTablesRestaurantConfigRequest());

    const date = parseDateToString(visitDate);
    return request.get(`${propertyId}/tables/restaurants/${restaurant}/${date}`).then(
      ({ data }) => dispatch(fetchTablesRestaurantConfigSuccess(data, restaurant)),
      (error) => {
        const parsedError = error.response ? error.response.data : error;
        dispatch(fetchTablesRestaurantConfigFailure(parsedError));
      }
    );
  };
